import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Card, Flex } from '@qga/roo-ui/components';

export const PlainSkeletonCard = styled(Box)`
  opacity: 0.6;
  overflow: hidden;
`;

export const OffersWrapper = styled(Flex)`
  flex-direction: column;
  flex-grow: 1;
`;

export const ShadowedSkeletonCard = styled(Flex)`
  opacity: 0.6;
  overflow: hidden;
  box-shadow: ${themeGet('shadows.result')};
  border-radius: ${themeGet('radii.default')};
  background-color: ${themeGet('colors.white')};
`;

export const BorderedSkeletonCard = styled(Card)`
  opacity: 0.6;
  overflow: hidden;
  width: 100%;
  border; ${themeGet('borders.1')} ${themeGet('colors.greys.dusty')};
`;
